import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import GeneralTableComponent from '../../components/GeneralCRUDComponent/GeneralTableComponent/GeneralTableComponent';
import {
  TableCellTypes,
} from '../../components/GeneralCRUDComponent/TableCellTypes/TableCellTypes';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  INewsCategoryStore,
} from '../../mobx-store/storeInterfaces/newsCategoryInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';

interface IProps extends WithSnackbarProps {
  newsCategoryStore: INewsCategoryStore;
  countryStore: CountryStore;
  history: any;
}
@inject('countryStore')
@inject('newsCategoryStore')
@observer
class NewsCategories extends Component<IProps> {
  addButton: any;

  tableHeader: any = [];

  tableData: any[] = [];

  tableCellTypes: TableCellTypes[] = [];

  title: string;

  constructor(props: IProps) {
    super(props);
    this.title = translate('newsCategoriesListPageTitle', {
    });
  }

  handleTableButtonCellClicked = (index: number, key: string) => {
    this.props.history.push(`/news-categories/${this.props.newsCategoryStore.categoriesList[index].categoryId}/edit`);
  };

  handelAdd = (): void => {
    this.props.history.push('/news-categories/new');
  };

  getAddCategoryButton = () => ({
    title: translate('newsCategoriesListAddButton', {
    }),
    onAdd: this.handelAdd,
  });

  getCategoriesTableHeader = () => [
    {
      title: translate('newsCategoriesListCategoryColumnTitle', {
      }),
    },
    {
      title: translate('newsCategoriesListEditColumnTitle', {
      }),
    },
  ];

  getCategoriesTableData = () => this.props.newsCategoryStore.categoriesList
    .map((category) => ({
      ...category, edit: 'Edit',
    }));

  getCategoriesTableCellTypes = (): TableCellTypes[] => [
    {
      cellType: 'Text',
      key: 'title',
    },
    {
      cellType: 'Button',
      key: 'edit',
      onClick: this.handleTableButtonCellClicked,
    },
  ];

  render() {
    this.addButton = this.getAddCategoryButton();
    this.tableHeader = this.getCategoriesTableHeader();
    this.tableData = this.getCategoriesTableData();
    this.tableCellTypes = this.getCategoriesTableCellTypes();
    return (
      <div>
        <GeneralTableComponent
          emptyMessage={translate('newsCategoriesListNoCategoriesMessage', {
          })}
          title={this.title}
          tableHeader={this.tableHeader}
          tableData={this.tableData}
          tableCellTypes={this.tableCellTypes}
          addButton={this.addButton}
          loadingStatus={[
            this.props.newsCategoryStore.getNewsCategoriesRequestStatus,
            this.props.countryStore.getManagedCountriesRequestStatus
          ]}
        />
      </div>
    );
  }

  async componentDidMount() {
    await this.props.countryStore.getUserManagedCountries();
    this.props.newsCategoryStore.getArticlesCategories(this.props.countryStore.managedCountries);
  }
}

export default NewsCategories;
